import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles(theme => ({
  root: {
    flexWrap: 'wrap',
    padding: theme.spacing(3, 2),
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
  },
}));

export default function CircularIndeterminate() {
  const classes = useStyles();

  return (
    <div className={classes.root} >
      <Paper className={classes.paper} style={{ marginTop: 10, padding: 30  }}>
    <h1>คุณไม่ได้อยู่กลุ่มLineแจ้งเตือนMesengerRafco</h1>
      <CircularProgress />
      <CircularProgress color="secondary" />
    </Paper>
    </div>
  );
}


// WEBPACK FOOTER //
// src/pages/components/nogroup.js